import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { POST_CONTEXT } from "../../../../lib/enums";
import PostForm from "../../../Common/PostForm";
import { deleteMailPosts, getMailPosts, openDialog } from "../../../../store/actions";
import Pager from "../../../Common/Pager";
import MailPostComponent from "./MailPost";
import { MailPost } from "../../../../lib/types";

interface IProps {
  presetRecipient?: string;
}

const mapStateToProps = (state: any) => ({
  mail: state.governorate.mail
})

const mapDispatchToProps = (dispatch: any) => ({
  getPostsDispatch: (page: number) => dispatch(getMailPosts(page)),
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  deletePostsDispatch: (postIds: number[]) => dispatch(deleteMailPosts(postIds))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const Mail = ({
  presetRecipient,
  mail,
  getPostsDispatch,
  openDialogDispatch,
  deletePostsDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [recipient, setRecipient] = useState<string>(presetRecipient || "");
  const [page, setPage] = useState<number>(1);
  const [postsToDelete, setPostsToDelete] = useState<number[]>([]);
  const upperDeleteRef = useRef<HTMLAnchorElement>(null);
  const lowerDeleteRef = useRef<HTMLAnchorElement>(null);
  const textAreaRef = React.createRef<HTMLTextAreaElement>();

  useEffect(() => {
    getPostsDispatch(page);
    setPostsToDelete([]);
  }, [page]);

  const toggleToDelete = (postId: number) => {
    const deleted = postsToDelete.slice();
    const postIndex = deleted.indexOf(postId);

    if (postIndex === -1) {
      deleted.push(postId);
    } else {
      deleted.splice(postIndex, 1);
    }

    setPostsToDelete(deleted);
  }

  const deletePosts = () => {
    deletePostsDispatch(postsToDelete);
    setPostsToDelete([]);
  }

  return (
    <>
      <h2 className="h2 h2-first">
        <span className="bordered">New post</span>
      </h2>
      <span className="divider"/>

      <section className="boxes-group">
        <div className="box">
          <div className="add-comment form clearfix">
            <div className="row">
              <div className="col-md-4">
                <input
                  type="input"
                  size={30}
                  className="input js-typeahead"
                  onChange={e => setRecipient(e.target.value)}
                  hint-name="hintGovName"
                  placeholder="Recipient name"
                  value={recipient}
                  data-source="/typeahead"
                />
              </div>
            </div>
          </div>
        </div>
        <PostForm context={POST_CONTEXT.Mail} recipient={recipient || ""} textAreaRef={textAreaRef}/>
        <span className="divider"/>
      </section>

      <section className="boxes-group">
        {mail && <>
        <div className="forum-header">
          <div className="left-actions">
            <a
              ref={upperDeleteRef}
              className="icon icon-smazat icon-xmd item icon-standalone"
              onClick={() => openDialogDispatch({
                name: "ConfirmDialog",
                clear: true,
                question: "Do you really want to delete selected posts?",
                cancel: "Back",
                confirm: "Delete",
                confirmAction: deletePosts,
                elementRef: upperDeleteRef.current
              })}
            />
          </div>
          {mail.pages > 1 && <Pager
            pages={mail.pages}
            page={page}
            bottom={false} setPage={setPage}
          />}
        </div>
          <span className="divider"/>
          <div className="box">
          <div className="comments" id="comments">
            {mail.posts && mail.posts.length ? mail.posts.map((post: MailPost) => <MailPostComponent
              key={post.id}
              post={post}
              toDelete={postsToDelete.includes(post.id)}
              toggleToDelete={() => toggleToDelete(post.id)}
              setRecipient={setRecipient}
            />) : <p className={"text-info"}>No mail found</p>}
          </div>
          </div>
          <span className="divider"/>
          <footer className="forum-footer load-block">
        {mail.pages > 1 && <Pager
          pages={mail.pages}
          page={page}
          bottom={true} setPage={setPage}/>}
          <div className="left-actions">
          <a
            ref={lowerDeleteRef}
            className="icon icon-smazat icon-xmd item icon-standalone"
            onClick={() => openDialogDispatch({
              name: "ConfirmDialog",
              clear: true,
              question: "Do you really want to delete selected posts?",
              cancel: "Back",
              confirm: "Delete",
              confirmAction: deletePosts,
              elementRef: lowerDeleteRef.current
            })}
          />
          </div>
          </footer>
        </>}
      </section>
    </>
  )
};

export default connector(Mail);
